<template>
  <SmoothResizer
    class="title-box"
    :isActive="!isMobile"
    @before-height-change="beforeHeightChange"
    @after-height-change="afterHeightChange"
  >
    <h1 class="title-box__title">{{ title }}</h1>
    <p class="title-box__description">{{ description }}</p>
  </SmoothResizer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SmoothResizer from '@/components/_shared/SmoothResizer.vue'

export default {
  name: 'TitleBox',
  components: {
    SmoothResizer,
  },

  computed: {
    ...mapState('filter', ['stickyMenuComponent']),

    ...mapGetters({
      isMobile: 'filter/isMobile',
      activeSubPage: 'filter/activeSubPage',
    }),

    title() {
      return this.activeSubPage?.title || ''
    },

    description() {
      return this.activeSubPage?.description || ''
    },
  },

  methods: {
    beforeHeightChange(additionalHeight) {
      this.stickyMenuComponent?.beforeHeightChange(additionalHeight, false)
    },

    afterHeightChange() {
      this.stickyMenuComponent?.afterHeightChange()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './TitleBox';
</style>
